/**
 * CardWrapper Compoent
 * Component for Basic Card view. Contain Header, info popover and control
 *
 * Props:
 * - title: String (Required)
 * - showTitle: boolean (Required)
 * - subtitle: String
 * - showSubtitle: boolean
 * - icon: String (Path for Icon)
 * - showIcon: boolean
 * - info: String (Markdown)
 * - showInfo: boolean
 * - showSaveAsImage: boolean
 * - showTable: boolean
 * - showDownloadTable: boolean
 * - functions: Object
 *   - saveAsImage: Function
 *   - getTable: Function
 * - options: Object
 * */

import React from "react";
import { Card, Menu, Row, Col, Popover, Dropdown, Image } from "antd";
import marked from "marked";
import { CSVLink } from "react-csv";
import { MoreOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const MocoCard = (props) => {
  // Destructuring props
  const {
    title,
    showTitle,
    subtitle,
    showSubtitle,
    icon,
    showIcon,
    info,
    showInfo,
    showSaveAsImage,
    showTable,
    showDownloadTable,
    functions,
    options,
    style,
    children,
    className,
  } = props;

  // console.log(props);

  // Declare menu component for Dropdown Menu in control
  const dropdownMenu = (
    <Menu>
      <Menu>
        {showSaveAsImage ? (
          <Menu.Item onClick={functions.saveAsImage}>
            Simpan Sebagai Gambar
          </Menu.Item>
        ) : null}
        {showTable ? (
          <Menu.Item onClick={functions.getTable}>Tampilkan Tabel</Menu.Item>
        ) : null}
        {showDownloadTable ? (
          <Menu.Item>
            <CSVLink
              data={options.dataSource}
              headers={options.columns.map((e) => {
                return {
                  label: e.title,
                  key: e.dataIndex,
                };
              })}
              filename={`${title}.csv`}
              separator=";"
            >
              Unduh Tabel
            </CSVLink>
          </Menu.Item>
        ) : null}
      </Menu>
    </Menu>
  );

  // Declare component info PopOver
  const popoverContent = (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: marked(info),
      }}
    />
  );

  // Declare component card header
  const heading = (
    <Row gutter={16} align="middle">
      {showIcon ? (
        <Col
          style={{
            maxWidth: 80,
          }}
        >
          <Image
            src={icon}
            style={{
              width: "100%",
              borderRadius: 18,
            }}
            preview={false}
          />
        </Col>
      ) : null}
      <Col span={20}>
        <span
          className="text-header text-normal"
          style={{
            whiteSpace: "pre-wrap",
            color: style === undefined ? "#1890ff" : style.titleColor,
          }}
        >
          {showTitle ? title : null}
        </span>
        <br />
        <span className="text-default text-normal">
          {showSubtitle ? subtitle : null}
        </span>
      </Col>
    </Row>
  );

  // Declare component for tooltips and control
  const tooltips = (
    <span>
      {showInfo ? (
        <Popover content={popoverContent}>
          <InfoCircleOutlined style={{ fontSize: 24 }} />
        </Popover>
      ) : null}
      {showSaveAsImage || showTable || showDownloadTable ? (
        <Dropdown overlay={dropdownMenu}>
          <MoreOutlined style={{ fontSize: 24 }} />
        </Dropdown>
      ) : null}
    </span>
  );

  return (
    <Card
      title={heading}
      extra={tooltips}
      style={{
        ...style,
        borderRadius: 15,
      }}
      className={`card ${className}`}
    >
      <div>{children}</div>
    </Card>
  );
};

// Declare data types for MocoCard props
MocoCard.propTypes = {
  title: PropTypes.string.isRequired,
  showTitle: PropTypes.bool.isRequired,
  subtitle: PropTypes.string,
  showSubtitle: PropTypes.bool.isRequired,
  icon: PropTypes.string,
  showIcon: PropTypes.bool.isRequired,
  info: PropTypes.string,
  showInfo: PropTypes.bool.isRequired,
  showSaveAsImage: PropTypes.bool.isRequired,
  showTable: PropTypes.bool.isRequired,
  showDownloadTable: PropTypes.bool.isRequired,
  functions: PropTypes.shape({
    saveAsImage: PropTypes.func,
    getTable: PropTypes.func,
  }),
  options: PropTypes.shape({
    columns: PropTypes.array,
    dataSource: PropTypes.array,
    filename: PropTypes.string,
  }),
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default MocoCard;
